import { Box, Stack, Text } from '@mantine/core';

import { NavLink } from 'react-router-dom';

const CampaignCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;
    return (
        <Box
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'start',
                gap: '16px',
            }}>
            <Text>{rowData.campaign?.name || '---'}</Text>
        </Box>
    );
};

const CampaignColumn = () => ({
    accessorKey: 'campaign.name',
    header: 'Campaign',
    size: 1,
    Cell: ({ cell }) => <CampaignCell cell={cell} />,
});
export default CampaignColumn;
